import React from 'react'; // Add this import
import { useEffect, useState } from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';
import { FaApple } from 'react-icons/fa';

interface MacOSUpdateProps {
  duration: number;
}

const MacOSUpdate = ({ duration }: MacOSUpdateProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    setProgress(100); // Trigger progress animation
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#000',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        zIndex: 9999,
      }}
    >
      <Box sx={{ mb: 4 }}>
        <FaApple size={64} />
      </Box>

      <Box sx={{ width: '30%', minWidth: 300 }}>
        <LinearProgress
          variant="determinate"
          value={progress}
          sx={{
            height: 8,
            borderRadius: 4,
            backgroundColor: 'rgba(255, 255, 255, 0.3)',
            '& .MuiLinearProgress-bar': {
              borderRadius: 4,
              transition: `transform ${duration}s linear`,
              backgroundColor: '#fff',
            },
          }}
        />
      </Box>

      <Typography variant="body1" sx={{ mt: 3, opacity: 0.8 }}>
        Estimating time remaining...
      </Typography>

      <Typography
        variant="caption"
        sx={{
          position: 'absolute',
          bottom: 40,
          opacity: 0.6,
          fontSize: '0.8rem',
        }}
      >
        Do not turn off your computer. This update will take several minutes to complete.
      </Typography>
    </Box>
  );
};

export default MacOSUpdate;